/**
 * Formato de `ORDER_NUMBER_RESET_TIME` (F15/D206): `HH:mm`, de `00:00` a `23:59`.
 *
 * Mora aqui porque os dois lados precisam concordar: a tela de Configurações valida com ele antes de gravar
 * e o backend lê a cfg com ele. Se divergirem, a tela aceita um valor que o backend descarta em silêncio, e
 * o número curto passa a virar às 05:00 sem ninguém ter pedido.
 */
export const ORDER_NUMBER_RESET_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;
